import Image from 'next/image';

import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { ReviewImage } from '../types';

import { styles } from './UiReviewGalleryBase.styles';

const MAX_VISIBLE_IMAGES_XL = 7;
const MAX_VISIBLE_IMAGES_LG = 5;
const MAX_VISIBLE_IMAGES_MD = 7;
const MAX_VISIBLE_IMAGES_SM = 6;
const MAX_VISIBLE_IMAGES_XS = 5;
const MAX_VISIBLE_IMAGES_DEFAULT = 4;

const MAX_VISIBLE_IMAGES = [
  MAX_VISIBLE_IMAGES_XL,
  MAX_VISIBLE_IMAGES_LG,
  MAX_VISIBLE_IMAGES_MD,
  MAX_VISIBLE_IMAGES_SM,
  MAX_VISIBLE_IMAGES_XS,
  MAX_VISIBLE_IMAGES_DEFAULT
];

export interface UiReviewGalleryBaseProps {
  images: ReviewImage[];
  onImageClick?: (imageId: string) => void;
}

export function UiReviewGalleryBase({
  images,
  onImageClick
}: UiReviewGalleryBaseProps) {
  const slots = styles();

  const isXl = useMediaQuery('xl');
  const isLg = useMediaQuery('lg');
  const isMd = useMediaQuery('md');
  const isSm = useMediaQuery('sm');
  const isXs = useMediaQuery('xs');

  const maxVisibleImages =
    MAX_VISIBLE_IMAGES[[isXl, isLg, isMd, isSm, isXs, true].findIndex(Boolean)];

  if (!images || images.length === 0) {
    return null;
  }

  const visibleImages = images.slice(0, maxVisibleImages);
  const hiddenCount = Math.max(0, images.length - maxVisibleImages);
  const hasHiddenImages = hiddenCount > 0;

  const getHandleImageClick = (imageId: string) => () => {
    onImageClick?.(imageId);
  };

  return (
    <>
      <div className={slots.base()}>
        {visibleImages.map((image, index) => (
          <button
            type="button"
            key={image.id}
            className={slots.imageContainer()}
            onClick={getHandleImageClick(image.id)}
          >
            <Image
              src={image.url}
              alt={image.alt || ''}
              className={slots.image()}
              width={100}
              height={100}
            />

            {hasHiddenImages && index === visibleImages.length - 1 && (
              <div className={slots.moreImages()}>+{hiddenCount}</div>
            )}
          </button>
        ))}
      </div>
    </>
  );
}
